(() => {

    "use strict";

    const SELECTOR = ".women-fashion-runner";

    /* ==========================================================
       ICONS (same paths as the old women-fashion-runner-icon snippet)
    ========================================================== */

    const ICONS = {

        sparkle: `<path d="M12 3L13.6 8.4L19 10L13.6 11.6L12 17L10.4 11.6L5 10L10.4 8.4L12 3Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>`,

        heart: `<path d="M12 20.5s-7-4.4-9-8.7C1.4 8.2 3.5 5 7.1 5c2 0 3.4 1 4.9 2.8C13.5 6 14.9 5 16.9 5c3.6 0 5.7 3.2 4.1 6.8-2 4.3-9 8.7-9 8.7z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>`,

        shipping: `<path d="M2.5 7H15V17H2.5Z" stroke="currentColor" stroke-width="1.8"/><path d="M15 10H18L21 13V17H15" stroke="currentColor" stroke-width="1.8"/><circle cx="7" cy="19" r="1.7" stroke="currentColor" stroke-width="1.8"/><circle cx="18" cy="19" r="1.7" stroke="currentColor" stroke-width="1.8"/>`,

        payment: `<rect x="3" y="5" width="18" height="14" rx="3" stroke="currentColor" stroke-width="1.8"/><path d="M3 9H21" stroke="currentColor" stroke-width="1.8"/><circle cx="17" cy="14" r="1.3" fill="currentColor"/>`,

        returns: `<path d="M8 5L4 9L8 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 9H14C17.5 9 20 11.5 20 15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>`,

        support: `<path d="M5 13V11C5 7.1 8.1 4 12 4C15.9 4 19 7.1 19 11V13" stroke="currentColor" stroke-width="1.8"/><rect x="3" y="12" width="4" height="6" rx="2" stroke="currentColor" stroke-width="1.8"/><rect x="17" y="12" width="4" height="6" rx="2" stroke="currentColor" stroke-width="1.8"/><path d="M19 18C19 20 17.5 21 15 21H13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>`,

        fire: `<path d="M13 3C13 6 9 7.5 9 11C9 13.5 10.8 15.5 13 15.5C15.5 15.5 17 13.5 17 11C17 8.8 15.8 7.2 15 6C14.3 4.9 14 4.1 13 3Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M12 15.5C9.8 15.5 8 17.2 8 19.3C8 20.8 9.7 22 12 22C14.3 22 16 20.8 16 19.3C16 17.2 14.2 15.5 12 15.5Z" stroke="currentColor" stroke-width="1.8"/>`,

        star: `<path d="M12 3L14.7 8.5L21 9.3L16.4 13.7L17.6 20L12 17L6.4 20L7.6 13.7L3 9.3L9.3 8.5L12 3Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>`,

        diamond: `<path d="M7 4H17L21 10L12 20L3 10L7 4Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>`,

        tag: `<path d="M12.6 2.7 20.3 10.4C20.9 11 20.9 12 20.3 12.6L13.6 19.3C13 19.9 12 19.9 11.4 19.3L3.7 11.6C3.4 11.3 3.2 10.9 3.2 10.5L3 4.5C3 3.7 3.7 3 4.5 3L10.5 3.2C10.9 3.2 11.3 3.4 11.6 3.7Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="8" cy="8" r="1.4" fill="currentColor"/>`,

        gift: `<rect x="3" y="9" width="18" height="12" rx="1.5" stroke="currentColor" stroke-width="1.8"/><path d="M3 9H21V6H3V9Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M12 9V21" stroke="currentColor" stroke-width="1.8"/><path d="M12 6C12 6 9.5 2.5 7 3.3C4.5 4.1 6 6 12 6Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M12 6C12 6 14.5 2.5 17 3.3C19.5 4.1 18 6 12 6Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>`,

        bag: `<path d="M6 8H18L17 21H7L6 8Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M9 8V6C9 4.3 10.3 3 12 3C13.7 3 15 4.3 15 6V8" stroke="currentColor" stroke-width="1.8"/>`,

        crown: `<path d="M4 18L3 8L8 11.5L12 6L16 11.5L21 8L20 18H4Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>`

    };

    const FALLBACK_ICON = `<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/>`;

    function getIconMarkup(name) {

        const inner = ICONS[name] || FALLBACK_ICON;

        return `<svg viewBox="0 0 24 24" fill="none">${inner}</svg>`;

    }

    /* ==========================================================
       CONTENT (text + icon per row, matched to a track by data-track-id)
    ========================================================== */

    const RUNNER_DATA = {

        "row-1": [
            { icon: "sparkle",  text: "SHEIN INSPIRED" },
            { icon: "heart",    text: "NEW ARRIVALS" },
            { icon: "shipping", text: "FAST DELIVERY" },
            { icon: "payment",  text: "CASH ON DELIVERY" },
            { icon: "returns",  text: "TRY BEFORE YOU BUY" },
            { icon: "star",     text: "PREMIUM QUALITY" },
            { icon: "tag",      text: "BEST PRICES" },
            { icon: "gift",     text: "SPECIAL OFFERS" },
            { icon: "bag",      text: "SHOP NOW" },
            { icon: "crown",    text: "EXCLUSIVE STYLES" }
        ],

        "row-2": [
            { icon: "diamond",  text: "TRENDING NOW" },
            { icon: "fire",     text: "HOT COLLECTION" },
            { icon: "support",  text: "24/7 SUPPORT" },
            { icon: "heart",    text: "SHOP YOUR STYLE" },
            { icon: "sparkle",  text: "NEW DROPS WEEKLY" },
            { icon: "shipping", text: "SAFE SHIPPING" },
            { icon: "crown",    text: "LIMITED EDITION" },
            { icon: "tag",      text: "SEASON SALE" },
            { icon: "gift",     text: "FREE GIFTS" },
            { icon: "bag",      text: "ADD TO CART" }
        ]

    };

    function buildGroup(items) {

        const group = document.createElement("div");
        group.className = "women-fashion-runner__group";

        items.forEach((data, idx) => {

            const item = document.createElement("div");
            item.className = "women-fashion-runner__item";
            item.innerHTML = `${getIconMarkup(data.icon)}<span>${data.text}</span>`;
            group.appendChild(item);

            if (idx < items.length - 1) {

                const sep = document.createElement("div");
                sep.className = "women-fashion-runner__separator";
                group.appendChild(sep);

            }

        });

        return group;

    }

    /* ==========================================================
       RUNNER
    ========================================================== */

    const MAX_CLONE_ITERATIONS = 80; // سقف أمان لكل استدعاء لـ ensureBuffer، عشان الحلقة متفضلش تضيف عناصر لانهائي في مرة واحدة

    class FashionRunner {

        constructor(section) {

            this.section = section;
            this.rows = [];
            this.raf = null;
            this.running = true;
            this.init();

        }

        init() {

            this.section
                .querySelectorAll(".women-fashion-runner__track")
                .forEach(track => {

                    const trackId = track.dataset.trackId;
                    const items = RUNNER_DATA[trackId];

                    if (!items || !items.length) return;

                    // نبني أول مجموعتين من البيانات مباشرة (بدل ما كانت بتتطبع من Liquid)
                    track.appendChild(buildGroup(items));
                    track.appendChild(buildGroup(items));

                    const firstGroup = track.querySelector(".women-fashion-runner__group");

                    if (!firstGroup) return;

                    const row = track.closest(".women-fashion-runner__row");

                    const rowData = {

                        row,

                        track,

                        template: firstGroup, // بنحتفظ بيه عشان نقدر نستنسخ منه في أي وقت لاحقًا

                        direction: row.classList.contains("women-fashion-runner__row--right")
                            ? 1
                            : -1,

                        speed: row.classList.contains("women-fashion-runner__row--right")
                            ? 0.06
                            : 0.05,

                        offset: 0,

                        paused: false,

                        // بنحسب المسافة بين العناصر مرة واحدة بس، مش كل فريم
                        gap: parseFloat(
                            getComputedStyle(track).columnGap ||
                            getComputedStyle(track).gap || 0
                        ) || 0

                    };

                    // تعبئة أولية كافية عشان اللوب يفضل مستمر من غير أي فراغ
                    this.ensureBuffer(rowData);

                    this.rows.push(rowData);

                    row.addEventListener("mouseenter", () => {

                        rowData.paused = true;

                    });

                    row.addEventListener("mouseleave", () => {

                        rowData.paused = false;

                    });

                });

        }

        /* ==========================================================
           BUFFER GUARANTEE
           بتتأكد إن التراك دايمًا فيه محتوى كافي قدام النقطة اللي
           بيتحرك عندها الشريط دلوقتي، وتضيف نسخ جديدة لو قل. بكده
           الشريط مستحيل "يخلص" أو يبان فيه فراغ، مهما اتغير حجم
           الشاشة أو طالت مدة تشغيل الأنيميشن.
        ========================================================== */

        ensureBuffer(row) {

            const groupWidth = row.template.getBoundingClientRect().width;

            if (groupWidth <= 0) return; // العنصر مخفي مؤقتًا، منعملش حاجة دلوقتي

            // بنحتاج محتوى يغطي: المسافة اللي الأوفست وصلها + عرض الشاشة × 3
            // كهامش أمان كبير، أيًا كان حجم الشاشة (ديسكتوب عادي أو ultra-wide)
            const neededWidth = Math.abs(row.offset) + (window.innerWidth * 3);
            const currentWidth = row.track.scrollWidth;

            if (currentWidth >= neededWidth) return;

            const clonesNeeded = Math.min(
                Math.ceil((neededWidth - currentWidth) / groupWidth),
                MAX_CLONE_ITERATIONS
            );

            if (clonesNeeded <= 0) return;

            const fragment = document.createDocumentFragment();

            for (let i = 0; i < clonesNeeded; i++) {

                fragment.appendChild(row.template.cloneNode(true));

            }

            row.track.appendChild(fragment); // كتابة واحدة بس = reflow واحد بس

        }

        start() {

            let lastTime = performance.now();
            let frameCount = 0;

            const loop = (time) => {

                if (!this.running) return;

                // لو التاب كان في الخلفية لفترة، الـ delta ممكن يبقى ضخم جداً
                // (ثواني بدل ميلي ثانية) - بنحط سقف بسيط عشان الشريط ميعملش
                // قفزة كبيرة أو يتلخبط لما المستخدم يرجع للتاب
                const rawDelta = time - lastTime;
                const delta = Math.min(rawDelta, 100);

                lastTime = time;

                frameCount++;

                this.rows.forEach(row => {

                    if (row.paused) return;

                    // try/catch لكل صف لوحده: لو حصل أي خطأ غير متوقع في صف واحد،
                    // الأنيميشن بتاعت باقي الصفوف وباقي الحلقة (loop) نفسها متتوقفش
                    // نهائي - كده الشريط فعلاً infinite ومايتجمدش خالص
                    try {

                        row.offset += row.speed * delta * row.direction;

                        row.track.style.transform = `translate3d(${row.offset}px,0,0)`;

                        this.recycle(row);

                        // كل حوالي 90 فريم (~1.5 ثانية) بنتأكد إن المخزون قدام
                        // الشريط لسه كافي، ولو لأ بنضيف نسخ جديدة فورًا - كده
                        // مستحيل يظهر فراغ أو "يخلص" الكلام مهما اتغير حجم الشاشة
                        if (frameCount % 90 === 0) {

                            this.ensureBuffer(row);

                        }

                    } catch (err) {

                        console.warn("women-fashion-runner: skipped a frame due to an error", err);

                    }

                });

                this.raf = requestAnimationFrame(loop);

            };

            this.raf = requestAnimationFrame(loop);

            this.observe();

        }

        recycle(row) {

            const gap = row.gap; // متخزنة مسبقًا، مش بتتحسب كل فريم

            // سقف أمان: عدد عناصر التراك × 2، عشان الـ while loop
            // يستحيل يفضل شغال لانهائي حتى لو حصل ظرف غريب (عنصر مخفي، عرض = صفر...إلخ)
            const maxIterations = row.track.children.length * 2 || 1;
            let iterations = 0;

            if (row.direction === -1) {

                // الحركة لليسار: لما أول عنصر (أو أكتر) يخرج بالكامل من الشاشة، ننقله لآخر الصف
                let first = row.track.firstElementChild;

                while (first && iterations < maxIterations) {

                    const firstWidth = first.getBoundingClientRect().width + gap;

                    // لو العنصر مخفي مؤقتًا (عرضه صفر) منوقفش هنا خالص عشان
                    // منعملش infinite loop - نكسر فورًا بدل ما نستنى شرط مستحيل يتحقق
                    if (firstWidth <= 0) break;

                    if (Math.abs(row.offset) < firstWidth) break;

                    row.track.appendChild(first);

                    row.offset += firstWidth;

                    first = row.track.firstElementChild;

                    iterations++;

                }

            } else {

                // الحركة لليمين: لما آخر عنصر (أو أكتر) يخرج بالكامل من الشاشة، ننقله لأول الصف
                let last = row.track.lastElementChild;

                while (last && iterations < maxIterations) {

                    const lastWidth = last.getBoundingClientRect().width + gap;

                    if (lastWidth <= 0) break;

                    if (row.offset < lastWidth) break;

                    row.track.insertBefore(last, row.track.firstElementChild);

                    row.offset -= lastWidth;

                    last = row.track.lastElementChild;

                    iterations++;

                }

            }

        }

        observe() {

            let resizeTimeout = null;

            window.addEventListener("resize", () => {

                // Debounce بسيط عشان الـ resize متتنفذش كل ميلي ثانية
                clearTimeout(resizeTimeout);

                resizeTimeout = setTimeout(() => {

                    this.rows.forEach(row => {

                        row.offset = 0;
                        row.track.style.transform = "";

                        // نعيد حساب الـ gap لو الـ breakpoint اتغير (مثلاً موبايل/ديسكتوب)
                        row.gap = parseFloat(
                            getComputedStyle(row.track).columnGap ||
                            getComputedStyle(row.track).gap || 0
                        ) || 0;

                        // الشاشة ممكن تكون كبرت بشكل كبير (خروج من وضع الموبايل،
                        // توصيل شاشة خارجية...إلخ) - نتأكد إن المخزون لسه كافي
                        this.ensureBuffer(row);

                    });

                }, 150);

            }, { passive: true });

        }

        destroy() {

            this.running = false;

            if (this.raf) {

                cancelAnimationFrame(this.raf);

            }

        }

    }

    function initRunner(root = document) {

        root.querySelectorAll(SELECTOR).forEach(section => {

            if (section.dataset.runnerReady === "true") return;

            section.dataset.runnerReady = "true";

            const runner = new FashionRunner(section);

            runner.start();

            section.__fashionRunner = runner;

        });

    }

    if (document.readyState === "loading") {

        document.addEventListener("DOMContentLoaded", () => initRunner());

    } else {

        initRunner();

    }

    document.addEventListener("shopify:section:load", (e) => {

        const section = e.target.matches(SELECTOR)
            ? e.target
            : e.target.querySelector(SELECTOR);

        if (!section) return;

        if (section.dataset.runnerReady === "true") return;

        section.dataset.runnerReady = "true";

        const runner = new FashionRunner(section);

        runner.start();

        section.__fashionRunner = runner;

    });

    document.addEventListener("shopify:section:unload", (e) => {

        const section = e.target.matches(SELECTOR)
            ? e.target
            : e.target.querySelector(SELECTOR);

        if (!section) return;

        if (section.__fashionRunner) {

            section.__fashionRunner.destroy();

            section.dataset.runnerReady = "false";

        }

    });

})();